/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update the email of a person
 * @export
 * @interface UpdateEmailPwrRequest
 */
export interface UpdateEmailPwrRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailPwrRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailPwrRequest
     */
    note?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailPwrRequest
     */
    isFavorite?: boolean;
}

/**
 * Check if a given object implements the UpdateEmailPwrRequest interface.
 */
export function instanceOfUpdateEmailPwrRequest(value: object): value is UpdateEmailPwrRequest {
    return true;
}

export function UpdateEmailPwrRequestFromJSON(json: any): UpdateEmailPwrRequest {
    return UpdateEmailPwrRequestFromJSONTyped(json, false);
}

export function UpdateEmailPwrRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmailPwrRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'note': json['note'] == null ? undefined : json['note'],
        'isFavorite': json['isFavorite'] == null ? undefined : json['isFavorite'],
    };
}

export function UpdateEmailPwrRequestToJSON(json: any): UpdateEmailPwrRequest {
    return UpdateEmailPwrRequestToJSONTyped(json, false);
}

export function UpdateEmailPwrRequestToJSONTyped(value?: UpdateEmailPwrRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'note': value['note'],
        'isFavorite': value['isFavorite'],
    };
}

